import { client } from "utils";

export const getMetricDataCollectionStatusRequest = () => client.get("metric-data/collection-status");
